export enum TabValidationStatuses {
  Wait = 'wait',
  Success = 'success',
  Error = 'error',
}
